import { req } from 'react-reqq-lite';

import { withAclReq } from 'modules/partial/hooks';
import { toastSuccess } from 'modules/common/toast';
import { GET_MERCHANT_PROFILE } from 'modules/merchant/profile/constant';

import * as c from './constants';
import { transformPayload } from './transformer';

export const createMerchant = (payload, callback = () => {}) => {
  req.post({
    key: c.CREATE_MERCHANT,
    url: `/v1/vendors`,
    payload: transformPayload(payload),
    onSuccess: () => {
      toastSuccess('Store successfully created');
      callback();
    },
  });
};

export const updateMerchantProfile = (
  merchant_uuid,
  payload,
  callback = () => {}
) => {
  req.put(
    withAclReq(
      () => ({
        ADMIN: {
          url: `/v1/vendors/${merchant_uuid}`,
        },
        MERCHANT: {
          url: '/v1/me/update-profile',
        },
      }),
      {
        key: c.UPDATE_MERCHANT_PROFILE,
        payload: transformPayload(payload),
        onSuccess: (res) => {
          req.set(GET_MERCHANT_PROFILE, (state) => {
            const data = state[GET_MERCHANT_PROFILE] || {};
            return {
              ...data,
              ...payload,
            };
          });
          toastSuccess(res?.message ?? 'Profile successfully updated');
          callback();
        },
      }
    )
  );
};
